export interface LibraryConfig {
  title: string;
  description: string;
  brandImage: string;
  backgroundColor: string;
}

export const LIBRARY_CONFIGS: Record<string, LibraryConfig> = {
  nextinvogue2024: {
    title: "Next In Vogue 2024",
    description:
      "Explore the latest trends and innovations in fashion technology",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/nextinvogue2024/images/nextinvoguelogo.png",
    backgroundColor:
      "radial-gradient(circle at 100%, #2A3E8A 0%, #64B445 100%)",
  },
  bemore2024: {
    title: "Be More 2024",
    description:
      "Personal development and growth strategies for the modern professional",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/bemore2024/images/669a8779d90d6d2480089811_Bemore+Logo.svg",
    backgroundColor:
      "radial-gradient(circle at 100%, #8c00f7 0%, #d7ec37 100%)",
  },
  "24fintech2024": {
    title: "24 FinTech 2024",
    description: "Cutting-edge financial technology insights and innovations",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/24fintech2024/images/logo.svg",
    backgroundColor:
      "radial-gradient(circle at 100%, #65b4f3 0%, #ef56fc 100%)",
  },
  aiewf2025: {
    title: "AI Engineer World's Fair 2025",
    description: "Cutting-edge technology insights and innovations",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/aiewf2025/images/logo.svg",
    backgroundColor: "radial-gradient(circle at 100%, #111 0%, #5EEAD4 100%)",
  },
};

// Extract just the titles for use in router
export const EVENT_TITLES: Record<string, string> = Object.fromEntries(
  Object.entries(LIBRARY_CONFIGS).map(([key, config]) => [key, config.title])
);

export const WEB_LIBRARY_ROUTES = [
  "WebLibraryHome",
  "StagePage",
  "TalkPage",
  "DayPage",
  "SearchResultsPage",
  "AgendaPage",
  "AboutPage",
  "LikeInfographics",
];
